import type { MemoryBankStats, MemoryCopy } from './types'

interface Props {
  copy: MemoryCopy
  stats: MemoryBankStats
}

export default function MemoryStoreSummary({ copy, stats }: Props) {
  const compactNumber = new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 })

  return (
    <div className="hidden shrink-0 items-center border-l border-border pl-5 xl:flex">
      <dl className="flex items-center gap-5">
        <Metric label={copy.summary.memories} value={compactNumber.format(stats.total_memories)} />
        <Metric label={copy.summary.documents} value={compactNumber.format(stats.total_documents)} />
        <Metric label={copy.summary.links} value={compactNumber.format(stats.total_links)} />
      </dl>
    </div>
  )
}

function Metric({ label, value }: { label: string; value: string }) {
  return (
    <div className="min-w-14">
      <dt className="text-[10.5px] font-medium text-faint-foreground">{label}</dt>
      <dd className="text-sm font-semibold tabular-nums text-foreground">{value}</dd>
    </div>
  )
}
